import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

function injectGTM(gtmId = 'GTM-TKCHNM8') {
    if (window.gtmInjected) return;
    window.gtmInjected = true;
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(inlineScript);
}

export function initCookieConsent() {
    CookieConsent.run({
        categories: {
            necessary: { enabled: true, readOnly: true },
            analytics: { enabled: false, readOnly: false }
        },
        language: {
            default: 'nl',
            translations: {
                nl: {
                    consentModal: {
                        title: 'Wij gebruiken cookies',
                        description: 'Zoals bij onze CNC-machines: zonder de juiste instellingen loopt het spaak! Cookies houden onze site soepel draaiend en geven ons inzicht in het gebruik – helemaal <strong>anoniem</strong> natuurlijk.',
                        acceptAllBtn: 'Akkoord',
                        acceptNecessaryBtn: 'Alleen functioneel',
                        showPreferencesBtn: 'Stel zelf in',
                        footer: '<a href="/privacy">Privacybeleid</a>'
                    },
                    preferencesModal: {
                        title: 'Jouw cookie-instellingen',
                        acceptAllBtn: 'Akkoord',
                        acceptNecessaryBtn: 'Alleen functioneel',
                        savePreferencesBtn: 'Opslaan',
                        closeIconLabel: 'Sluiten',
                        sections: [
                            {
                                title: 'Cookie-gebruik',
                                description: 'Onze digitale gereedschapskist: functionele cookies voor een soepel draaiende site, analytics voor kwaliteitscontrole. Geen koekje? Geen probleem!'
                            },
                            {
                                title: 'Strikt noodzakelijke cookies',
                                description: 'Net als de noodstop op een machine: deze cookies zijn essentieel en kunnen niet uit.',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Prestatie & Analytics',
                                description: 'Onze kwaliteitscontroleurs! Meten is weten, dus deze cookies helpen ons verbeteren. Alles anoniem.',
                                linkedCategory: 'analytics'
                            }
                        ]
                    }
                },
                en: {
                    consentModal: {
                        title: 'We use cookies 🍪',
                        description: 'Just like our CNC machines: without the right settings, things grind to a halt! Cookies keep our site running smoothly and help us understand usage – all anonymously.',
                        acceptAllBtn: 'Give me the cookies!',
                        acceptNecessaryBtn: 'Functional only',
                        showPreferencesBtn: 'Set preferences',
                        footer: '<a href="/privacy-policy">Privacy Policy</a>'
                    },
                    preferencesModal: {
                        title: 'Your cookie settings',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Functional only',
                        savePreferencesBtn: 'Save',
                        closeIconLabel: 'Close',
                        sections: [
                            {
                                title: 'Cookie usage',
                                description: 'Our digital toolbox: functional cookies for a smooth site, analytics for quality control. No cookie? No problem!'
                            },
                            {
                                title: 'Strictly necessary cookies',
                                description: 'Like the emergency stop on a machine: these cookies are essential and cannot be disabled.',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Performance & Analytics',
                                description: 'Our quality inspectors! Measuring is knowing, so these cookies help us improve. All anonymous.',
                                linkedCategory: 'analytics'
                            }
                        ]
                    }
                }
            }
        },
        guiOptions: {
            consentModal: {
                layout: 'box inline',
                position: 'bottom right',
                transition: 'slide'
            },
            preferencesModal: {
                layout: 'box',
                position: 'center',
                transition: 'slide'
            }
        },
        autoShow: true,
        pageScripts: false,
        cookie: {
            name: 'cc_cookie',
            domain: window.location.hostname,
            path: '/',
            sameSite: 'Lax',
            expiresAfterDays: 182
        },
        onConsent: ({cookie}) => {
            if (cookie.categories.includes('analytics')) {
                injectGTM('GTM-TKCHNM8');
            }
        },
        onChange: ({cookie, changedCategories}) => {
            console.log('change', cookie);
            if (changedCategories.includes('analytics') && cookie.categories.includes('analytics')) {
                injectGTM('GTM-TKCHNM8');
            }
        }
    });

    // On reload, inject GTM if analytics consent already given
    if (CookieConsent.acceptedCategory('analytics')) {
        injectGTM('GTM-TKCHNM8');
    }
}
